// Central configuration for the application
export const APP_CONFIG = {
  name: 'Playground Admin',
  version: '0.1.0',
  environment: process.env.NODE_ENV || 'development',
};

export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_URL || 'https://test-admin.api.bearswithapps.com',
  publicBaseURL: process.env.REACT_APP_PUBLIC_API_URL || 'https://test.api.bearswithapps.com',
  apiKey: process.env.REACT_APP_API_KEY || 'pub_zsd1.asd3.009ASz',
  mapboxToken: process.env.REACT_APP_MAPBOX_TOKEN || '',
  endpoints: {
    admin: '/admin',
    report: '/admin?cmd=report',
    geocode: '/admin?cmd=geocode',
    stats: '/admin?cmd=stats',
    coverageKml: '/admin?cmd=coveragekml',
    advertising: '/admin?cmd=advertising',
    staged: (status = 'none', includeParent = false) => {
      const params = new URLSearchParams({ status });
      if (includeParent) {
        params.set('includeParent', 'true');
      }
      return `/admin/staged?${params.toString()}`;
    },
    history: (id) => `/admin?id=${encodeURIComponent(id)}&cmd=history`,
    accept: (id) => `/admin?id=${encodeURIComponent(id)}&cmd=accept`,
    unflag: (id) => `/admin?id=${encodeURIComponent(id)}&cmd=unflag`,
    playgroundById: (id) => `/admin?id=${encodeURIComponent(id)}`,
    search: (query) => `/admin?q=${encodeURIComponent(query)}`,
    venture: (query) => `/admin?q=${encodeURIComponent(query)}&cmd=venture`,
    ventureByHash: (hash) => `/admin?hash=${hash}&cmd=venture`,
    geocodeById: (id) => `/admin?id=${encodeURIComponent(id)}&cmd=geocode`,
    installs: (days) => `/playground?cmd=installs&days=${days}`,
    installSummary: '/admin?cmd=installsummary',
    // Public endpoints that use API key instead of user auth
    playground: (lat, lon) => `/playground?lat=${lat}&lon=${lon}`,
    // New endpoints for add/update items page
    geocodePlace: (placeName) => `/playground?cmd=geocode&q=${encodeURIComponent(placeName)}`,
    searchByLocation: (lat, lon, tp, miles) => {
      const params = new URLSearchParams({ lat: lat.toString(), lon: lon.toString() });
      if (tp) params.append('tp', tp);
      if (miles) params.append('miles', miles.toString());
      return `/playground?${params.toString()}`;
    },
    createPlayground: () => '/playground',
    updatePlayground: (id) => `/playground/${id}`,
    flagPlayground: (id) => `/playground/${id}`,
    verifier: (id, enableMCP = true) => {
      const params = new URLSearchParams({ id });
      if (enableMCP) {
        params.append('enableMCP', 'true');
      }
      return `/admin/verifier?${params.toString()}`;
    },
    adminAiHelp: (id) => `/admin/aihelp?id=${encodeURIComponent(id)}`,
    uploadImage: () => '/playground/images',
    adminUploadImage: () => '/admin/images',
    analyzeImage: () => '/admin/analyze',
    depersonalizeImage: () => '/admin/depersonalize',
    adminUpload: '/admin/upload',
    adminIcons: '/admin/icons',
  },
  timeout: 30000,
  retryAttempts: 3,
};

export const UI_CONFIG = {
  notifications: {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
  },
  map: {
    defaultCenter: [0, 0],
    defaultZoom: 2,
    tileLayer: {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    },
  },
  pagination: {
    defaultPageSize: 50,
    pageSizeOptions: [25, 50, 100, 200],
  },
};

export const VALIDATION_CONFIG = {
  playground: {
    nameMaxLength: 255,
    descriptionMaxLength: 1000,
    requiredFields: ['name', 'center'],
  },
  search: {
    minQueryLength: 1,
    maxQueryLength: 100,
  },
};

export const FEATURE_FLAGS = {
  enableAdvancedFilters: true,
  enableBulkOperations: true,
  enableRealTimeUpdates: false,
  enableAnalytics: true,
};